export default __webpack_public_path__ + "static/media/logo.2a71e2d7.png";